module.exports = __webpack_public_path__ + "img/122.f6b01371.png";